export enum PurchaseStatus {
    NEW = 'NEW',
    COMPLETED = 'COMPLETED',
    CANCELLED = 'CANCELLED',
}